import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

const PublicErrorHandling = (props) => {
    const {
        t
    } = props;
    const [seconds, setSeconds] = React.useState(5);
    const PUBLIC_URL= 'https://public.tableau.com/'
    React.useEffect(() => {
        if (seconds > 0) {
            setTimeout(() => setSeconds(seconds - 1), 1000);
        } else {
            window.location.href = PUBLIC_URL;
        }
    });
     return (
        <div className="text--link" data-testid='link'>
            <br/>
            {`${t('You_will_be_automatically_redirected_to_Tableau_Public_in')}`}  <strong>{seconds}</strong> {`${t('seconds')}`}.  <br/>
            {`${t('Please_try_logging_in_again.')}`}
        </div>
     )
};

PublicErrorHandling.prototypes = {
    t: PropTypes.func.isRequired,
}
export default translate()(PublicErrorHandling);